import { useLocation, useNavigate } from "react-router-dom";
import { useSettings } from "@/hooks/SettingsContext";
import { trackPlanVisitClick } from "@/lib/analytics";

export default function AnnouncementBar() {
  const { settings } = useSettings();
  const location = useLocation();
  const navigate = useNavigate();
  if (location.pathname.startsWith("/admin")) return null;
  if (!settings?.announcement_enabled || !settings?.announcement_text) return null;

  const go = (e) => {
    e.preventDefault();
    trackPlanVisitClick();
    if (settings.launch_mode) {
      navigate("/");
      setTimeout(() => document.getElementById("service-1")?.scrollIntoView({ behavior: "smooth" }), 400);
    } else {
      navigate("/im-new");
    }
  };

  return (
    <div className="bg-victory px-3 py-1.5 text-center sm:px-4" data-testid="announcement-bar">
      <p className="text-[11px] font-semibold leading-snug tracking-[0.08em] text-white sm:text-xs">
        {settings.announcement_text}{" "}
        <a href="/#service-1" onClick={go} data-testid="announcement-cta"
           className="ml-1.5 inline-block rounded-full bg-navy px-2.5 py-0.5 font-display text-[10px] font-700 text-white transition-colors hover:bg-navy-dark">
          {settings.announcement_cta_label || "LEARN MORE"}
        </a>
      </p>
    </div>
  );
}
